import { formatBRL, formatDocument, formatPhoneBR, formatZip } from '@oficina/shared';

export { formatBRL as money, formatDocument, formatPhoneBR as formatPhone, formatZip };

const TZ = 'America/Sao_Paulo';

/** "2026-10-03" → "03/10/2026" (datas sem hora não sofrem conversão de fuso). */
export function formatDate(value: string | null | undefined) {
  if (!value) return '—';
  const m = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m && value.length === 10) return `${m[3]}/${m[2]}/${m[1]}`;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? value : d.toLocaleDateString('pt-BR', { timeZone: TZ });
}

export function formatDateTime(value: string | Date | null | undefined) {
  if (!value) return '—';
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime())
    ? String(value)
    : d.toLocaleString('pt-BR', { timeZone: TZ, dateStyle: 'short', timeStyle: 'short' });
}

export function todayISO() {
  return new Intl.DateTimeFormat('en-CA', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit' }).format(
    new Date(),
  );
}

export function nowTime() {
  return new Intl.DateTimeFormat('pt-BR', { timeZone: TZ, hour: '2-digit', minute: '2-digit', hour12: false }).format(
    new Date(),
  );
}

/** "2026-10" → "out/26" (rótulo do gráfico, como no protótipo). */
export function monthLabel(ym: string) {
  const [y, m] = ym.split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, 15))
    .toLocaleDateString('pt-BR', { month: 'short', year: '2-digit', timeZone: 'UTC' })
    .replace('.', '')
    .replace(' de ', '/');
}

export const initials = (name: string | null | undefined) =>
  String(name ?? '')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase())
    .join('') || '?';

export const plural = (n: number, one: string, many: string) => `${n} ${n === 1 ? one : many}`;
